import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from '../../../shared/shared.module';
import { MaterialModule } from '@modules/material.module';
import { PrimengModule } from '@modules/primeng.module';

import { HtmlTemplateEditorComponent } from './components/html-template-editor/html-template-editor.component';
import { VisualizacaoTemplateHtmlComponent } from './components/visualizacao-template-html/visualizacao-template-html.component';

@NgModule({
  declarations: [
    HtmlTemplateEditorComponent,
    VisualizacaoTemplateHtmlComponent,
  ],
  imports: [
    BrowserModule,
    SharedModule,
    MaterialModule,
    PrimengModule,
  ],
  exports: [
    HtmlTemplateEditorComponent,
    VisualizacaoTemplateHtmlComponent,
  ],
})
export class VistoriaSharedModule { }
